import React, { useEffect, useState } from 'react';
import { useStateValue } from '../context/StateProvider';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Autoplay, Pagination } from 'swiper/modules';
import { motion } from 'framer-motion';
import './../index.css';
import Banner from './../image/Banner.mp4';
import { Link } from 'react-router-dom';
import Background from './../image/background.jpeg'
import { MdOutlineWifiCalling3 } from 'react-icons/md';
import { FaPhoneAlt, FaTimes } from 'react-icons/fa';
import USA from './../image/3.png'
import { Loader } from '.';
import { toast } from 'react-toastify';
const ViewSlider = () => {
  const [{ Slider }] = useStateValue();
  const [isOpen, setIsOpen] = useState(false);
  const [chatbaseLoaded, setChatbaseLoaded] = useState(false);
  const [callbackFormData, setCallbackFormData] = useState({
    mobile: '',
    message: ''
  });

  const chatbaseBotId = 'MtfIWOK21xTYPZI91WHoO';
  const chatbaseEmbedUrl = 'https://www.chatbase.co/embed.min.js';
  const chatbaseDomain = 'www.chatbase.co';
  const chatbaseScriptId = chatbaseBotId; // Use botId as script ID

  const formatQuote = (quote) => {
    const words = quote.split(' ');
    if (words.length > 0) {
      const lastWord = words.pop();
      return (
        <>
          {words.join(' ')} <span className="text-gray-400">{lastWord}</span>
        </>
      );
    }
    return quote;
  };

  const handleCallbackChange = (e) => {
    const { name, value } = e.target;
    setCallbackFormData({ ...callbackFormData, [name]: value });
  };

  const handleCallbackSubmit = (e) => {
    e.preventDefault();
    if (!callbackFormData.mobile) {
      toast.error('Please enter your mobile number for a call back.');
      return;
    } else if (callbackFormData.mobile.length !== 10 || !/^[0-9]+$/.test(callbackFormData.mobile)) {
      toast.error('Please enter a valid 10-digit phone number for call back.');
      return;
    }
    if (!callbackFormData.message) {
      toast.error('Please enter your message for the call back request.');
      return;
    }

    console.log('Callback Request:', callbackFormData);
    toast.success('Your call back request has been submitted!');
    setCallbackFormData({ mobile: '', message: '' });
    setIsOpen(false);
  };
  const loadChatbaseScript = () => {
    if (!document.getElementById(chatbaseScriptId)) {
      const script = document.createElement('script');
      script.id = chatbaseScriptId;
      script.src = chatbaseEmbedUrl;
      script.async = true;
      script.domain = chatbaseDomain;
      script.onload = () => {
        console.log('Chatbase script loaded successfully');
        setChatbaseLoaded(true);
      };
      script.onerror = (error) => {
        console.error('Error loading Chatbase script:', error);
      };
      document.body.appendChild(script);
      console.log('Chatbase script tag appended to body');
    } else {
      console.log('Chatbase script element already exists.');
      setChatbaseLoaded(true);
    }
  };

  useEffect(() => {
    loadChatbaseScript();
  }, []);

  return (
    <section
      className="w-full h-full overflow-hidden lg:mt-28 sm:mt-1 md:mb-16 mb-3 relative bg-[#fafafa] px-4 lg:px-10 lg:p-0 p-4 z-0"
      style={{ backgroundImage: `url(${Background})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
    >
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 3000 }}
        pagination={{ clickable: true }}
        loop={true}
        modules={[Autoplay, Pagination]}
        className="flex items-center justify-center"
      >
        {Slider && Slider.length > 0 ? (
          Slider.map((banner) => (
            <SwiperSlide key={banner.id} className="relative">
              <div className="w-full h-full flex flex-col lg:flex-row lg:items-center">
                {/* Content on Left Side */}
                <div className="w-full lg:w-1/2 h-full flex flex-col justify-center items-start z-10 p-6">
                  <motion.p
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="lg:text-md text-sm mt-2 text-[#0e55a8] font-bold"
                  >
                    IT CONSULTING SERVICES
                  </motion.p>

                  <motion.h2
                    initial={{ y: -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="lg:text-[47px] text-4xl font-semibold text-black text-left leading-[1.2] lg:leading-[1.2]"
                  >
                    {banner.title.split(' ').map((word, index) => (
                      <span
                        key={index}
                        className={[2, 3, 5, 7].includes(index + 1) ? 'text-[#0e55a8]' : 'text-black'}
                      >
                        {word}{' '}
                      </span>
                    ))}
                  </motion.h2>
                  <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, staggerChildren: 0.2 }}
                    className='text-justify text-[16px] text-[#6d6d70]'
                  >
                    {(() => {
                      // Split text by "." and filter out empty items
                      const sentences = banner?.quotes?.split(".").filter((item) => item.trim());

                      // Join first two sentences into the first paragraph
                      const firstParagraph = sentences.slice(0, 2).join(". ") + ".";

                      // Join remaining sentences into the second paragraph (if any)
                      const secondParagraph = sentences.slice(2).join(". ");

                      return (
                        <>
                          <motion.p className="lg:text-[1rem] lg:w-[600px] w-full text-md mt-2 text-[#8d8d91] font-normal leading-[1.8]">
                            {firstParagraph}
                          </motion.p>

                          {secondParagraph && (
                            <motion.p className="lg:text-[1rem] lg:w-[600px] w-full text-md mt-2 text-[#8d8d91] font-normal leading-[1.8]">
                              {secondParagraph}.
                            </motion.p>
                          )}
                        </>
                      );
                    })()}
                  </motion.div>


                  <div className="lg:flex sm:flex-col lg:flex-row mt-10 gap-4">
                    <motion.a
                      href="/contact"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: 0.2 }}
                      className="inline-flex items-center gap-2 px-6 py-3 text-white lg:mb-0 mb-2 rounded-[5px] bg-[#0e55a8] font-medium shadow-md hover:bg-white hover:text-[#005eb8] border border-[#005eb8]"
                    >
                      <MdOutlineWifiCalling3 size={20} /> Talk to our team
                    </motion.a>
                    {/* <motion.a
                      href="/contact"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: 0.3 }}
                      className="inline-block px-6 py-3 rounded-[5px] text-white bg-gradient-to-r from-[#d75074] via-[#a843a6] to-[#7c37d7] transition-all duration-300 shadow-md  hover:shadow-lg border "
                    >
                      Get In Touch
                    </motion.a> */}

                  </div>
                </div>

                <div className="w-full lg:w-1/2 relative mt-20 mb-20 sm:flex-row ">

                  {/* Video on Small Screens */}
                  <motion.video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="object-fill w-full lg:h-[40vh] h-[35vh] sm:block lg:hidden"
                    initial={{ scale: 1 }}
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatType: 'reverse' }}
                  >
                    <source src={Banner} type="video/mp4" />
                  </motion.video>

                  {/* Top Left Box */}
                  <motion.div
                    initial={{ opacity: 0.8, scale: 1 }}
                    animate={{
                      rotate: [0, 10, -10, 0],
                      scale: [1, 1.05, 1],
                      opacity: [0.8, 1, 0.8],
                      y: [0, -10, 0],
                    }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatDelay: 2 }}
                    className="bg-gradient-to-r from-gray-200 to-[#c2e1f8] w-[160px] text-white p-4 rounded-md shadow-lg
  hidden lg:block lg:absolute -top-10 -left-5 z-10"
                  >
                    <p className="text-[12px] text-black">SMALL TACTICS</p>
                    <h4 className="text-md font-semibold text-[#0e55a8]">Consulting</h4>
                    <p className="text-[13px] text-gray-600">
                      Nexify provides tech staffing and staff augmentation solutions
                    </p>
                    <Link to="/consulting" className="text-[#0e55a8] text-[11px] font-semibold cursor-pointer">
                      Read More &gt;&gt;
                    </Link>
                  </motion.div>

                  {/* Bottom Right Box */}
                  <motion.div
                    initial={{ opacity: 0.8, scale: 1 }}
                    animate={{
                      rotate: [0, -10, 10, 0],
                      scale: [1, 1.05, 1],
                      opacity: [0.8, 1, 0.8],
                      y: [0, -10, 0],
                    }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatDelay: 2 }}
                    className="bg-gradient-to-l from-white to-[#d3e4f1] w-[160px] text-white p-4 rounded-md shadow-lg 
  hidden lg:block lg:absolute -bottom-10 right-5 z-10">
                    <p className="text-[12px] text-black">PLAN, THEN DO</p>
                    <h4 className="text-md font-semibold text-[#0e55a8]">IT Services</h4>
                    <p className="text-[13px] text-gray-600">
                      Nexify provides tech solutions to optimize operations and drive innovation
                    </p>
                    <Link to="/service" className="text-[#0e55a8] text-[11px] font-semibold cursor-pointer">
                      Read More &gt;&gt;
                    </Link>
                  </motion.div>

                  {/* Video for Large Screens */}
                  <motion.video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="object-cover w-full h-full hidden lg:block z-0"
                    initial={{ scale: 1 }}
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 8, ease: 'easeInOut', repeat: Infinity, repeatType: 'reverse' }}
                  >
                    <source src={Banner} type="video/mp4" />
                  </motion.video>
                </div>

              </div>
            </SwiperSlide>
          ))
        ) : (
          <div className="text-center text-xl w-full h-full flex items-center justify-center">
            <Loader />
          </div>
        )}
      </Swiper>
      
    </section>
  );
};

export default ViewSlider;
